import {Component, computed, effect, inject, resource, signal, Signal} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {GenericApiService} from "../../../shared/api/generic-api.service";
import {toSignal} from "@angular/core/rxjs-interop";
import {LoaderElementComponent} from "../../../shared/loader-element/loader-element.component";
import {TranslatePipe} from "@ngx-translate/core";
import {Router, RouterLink, RouterOutlet} from "@angular/router";
import {v4 as uuid} from 'uuid';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-user-listing',
    imports: [
        FormsModule,
        LoaderElementComponent,
        TranslatePipe,
        RouterOutlet,
        RouterLink
    ],
  templateUrl: './user-listing.component.html',
  styleUrl: './user-listing.component.scss'
})
export class UserListingComponent {
    private readonly http = inject(HttpClient);
    private readonly router = inject(Router);

    //handles visibility of product list
    protected subRouteActive = signal(false);

    private userState = signal(uuid());

    private usersResource = resource({
        request: this.userState,
        loader: async (resource)=> new Promise((resolve => this.http.get("/api/loginUser").subscribe(resolve)))
    })

    //fetched users
    protected users: Signal<any> = computed(()=> this.usersResource.value() );

    //user filter input
    protected searchStr: Signal<string> = signal("");

    //output to ui of user
    protected filteredUsers: Signal<any> = computed(() => this.users()?.filter((user: any) =>
        this.searchStr() === '' ||
        user.email.includes(this.searchStr()) ||
        user.phoneNumber.includes(this.searchStr()) ||
        user.company?.name.includes(this.searchStr())
    ));

    //listens routeroutlet for route changes and toggles visibility of product list
    onRouteChange(value: boolean) {
        this.subRouteActive.set(value);
        if(!value)this.userState.set(uuid());
    }

    onDeleteUSer(user: any) {
        if(confirm(`Are you sure you want to delete ${user.email}?`)){
            this.http.delete(`/api/loginUser/${user.id}`).subscribe(() => {
                this.userState.set(uuid());
            });
        }
    }

}
